import burgerMenu from "./layout/burgerMenu";
import sliders from './components/sliders';
import checkUserBrowser from "./components/checkUserBrowser";
import search from "./components/search";
import listView from "./components/listView";
import cookies from "./components/cookies";
import singleArticle from "./layout/singleArticle";
import filters from "./components/filters";
import Simplebar from "simplebar";
import faqPage from "./pages/faq";
import contactPage from "./pages/contact";
import inputPlaceholder from "./components/input-placeholder";
import comparison from "./pages/comparison";
import themeSwitch from "./components/theme-switch";
import addComparison from "./components/addComparison";
import order from './pages/order';
import Splide from '@splidejs/splide';
import gallery from "./components/projectGallery";
import stickySummary from "./components/stickySummary";
import sort from "./components/sort";
import searchProject from "./components/searchProject";
import articleForm from "./components/articleForm";
import returnTop from "./components/returnTop";
import lookingProject from "./pages/lookingProject";
import LazyLoad from "./components/imageLazyLoad";

document.addEventListener("DOMContentLoaded", function(){
    const lazyLoader = new LazyLoad('.lazy');
    singleArticle(Splide);
    const docCookies = cookies();
    checkUserBrowser();
    burgerMenu();
    sliders(Splide);
    search();
    listView(docCookies);
    filters(Simplebar);
    faqPage();
    contactPage();
    inputPlaceholder();
    comparison();
    themeSwitch();
    addComparison();
    order();
    gallery(Splide);
    stickySummary(Simplebar);
    sort();
    searchProject();
    articleForm(Simplebar);
    returnTop();
    lookingProject();
});
